import React, { useEffect, useState } from 'react';
import { BookModel } from '../../../../../interfaces/book.interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { SecureImg } from '../../../../../components/Common/SecureImage';

interface CharacterPortraitProps {
  currentPortrait: string | null;
  storyData: BookModel;
  shouldCoverPortrait: boolean;
  currentPortraitList: string[];
  handleDeleteImage: () => void;
  getCharactersMatchingLibrary: (customCharacterId: string) => string[];
  setCurrentPortrait: (portrait: string) => void;
}

const CharacterPortrait: React.FC<CharacterPortraitProps> = ({
  currentPortrait,
  storyData,
  shouldCoverPortrait,
  currentPortraitList,
  handleDeleteImage,
  getCharactersMatchingLibrary,
  setCurrentPortrait,
}) => {
  const [currentCharacterPortraitList, setCurrentCharacterPortraitList] = useState<string[]>([]);

  useEffect(() => {
    if (
      currentPortraitList?.length > 0 &&
      (!currentCharacterPortraitList?.length || currentPortraitList[0] !== currentCharacterPortraitList[0])
    ) {
      setCurrentCharacterPortraitList(currentPortraitList);
    }
  }, [currentPortraitList]);
  return (
    <div className="text-center">
      {currentPortrait && (
        <div className="relative">
          <div className="mr-0 lg:mr-2 absolute top-4 right-[1rem] md:right-[10rem] lg:right-24 w-10 h-10 bg-white rounded-md">
            <FontAwesomeIcon
              icon={faTrashCan}
              className={`mt-2 text-[#EF4444] text-2xl cursor-pointer`}
              onClick={() => {
                handleDeleteImage();
              }}
            />
          </div>
          <SecureImg
            storageSrc={currentPortrait! || storyData?.uploadedImage!}
            className={`h-[20rem] w-[18rem] md:h-[25rem] md:w-[25rem] mx-auto rounded-[1.5rem] mb-4 ${
              shouldCoverPortrait ? 'object-cover' : ''
            }`}
            placeholderClassName={`flex justify-center items-center min-h-[20rem] min-w-[18rem] md:min-h-[25rem] md:min-w-[25rem] mx-auto rounded-[1.5rem] mb-4`}
            showLoader={true}
          />
          <h1 className="w-[19rem] mx-auto md:w-[24rem] text-xs text-left">
            AI-generated content may not always be 100% accurate or free from errors.
          </h1>
        </div>
      )}
      {currentCharacterPortraitList &&
        getCharactersMatchingLibrary(storyData?.illustrationCharacter?.pageData?.customCharacterId!)?.length > 1 && (
          <div className="flex gap-4 md:gap-6 justify-center">
            {getCharactersMatchingLibrary(storyData?.illustrationCharacter?.pageData?.customCharacterId!)?.map(
              (img: string) => {
                const imageClass = currentPortrait === img ? 'border-2 border-storyblue' : 'opacity-50';
                return (
                  <img
                    src={img}
                    className={`h-14 md:h-20 w-14  md:w-20 rounded-md my-4 cursor-pointer ${imageClass}`}
                    onClick={() => {
                      setCurrentPortrait(img);
                    }}
                  />
                );
              },
            )}
          </div>
        )}
    </div>
  );
};

export default CharacterPortrait;
